<template>
  <div id="popup">  
    <h6 class="popup-content pr-2">{{name}}
      <img src="@/assets/img/open_project_orange.svg" 
      class="img" alt="" @click="$root.$emit('openVideoModeFromPopup', id)">
    </h6>    
  </div>
</template>
<script>
  export default {
    props: ['name', 'id', 'subsections'],
  }
</script>
<style>
 .popup-content{
  white-space:nowrap;
  margin:-0.5rem;      
}
.img{
  padding: 0.3rem;  
  margin:0.1rem;
  border-radius:0.4rem;
}
.img:hover {
  background:  rgba(0,0,0,.2);
  cursor: pointer;
}
</style>